<!--
作成者：Nakatsuka Daisuke
作成日：2020.10.21
画面名：物件情報登録・修正・照会
機能：物件情報登録・修正・照会
親子関係：なし
更新者：Nakatsuka Daisuke
①
更新内容：表示修正
①
-->
<template>
  <div>
    <div v-if="!modalFlag" class="row grid-margin mx-0 px-0">
      <b class="font-weight-bold">
        物件{{ mode == 'Add' ? '登録' : mode == 'View' ? '管理' : '情報変更' }}
      </b>
      <!-- 上部ボタン -->
      <b-navbar-nav class="ml-auto">
        <router-link to="/Property/List?page=true" tag="button" class="btn btn-ally">
          物件一覧に戻る
        </router-link>
      </b-navbar-nav>
    </div>

    <div class="row grid-margin mx-0 px-0">
      <div class=" col-12" v-if="upLoading">
        <Load />
      </div>
      <div class="ally-input-background card col-12" v-if="!upLoading">
        <div class="card-body" v-if="!loading">
          <ValidationObserver ref="propertyInfo">
            <!-- 物件情報 -->
            <h4 class="font-weight-bold">物件情報</h4>
            <div class="card-body">
              <div class="row">
                <div class="ally-input-background  col-11">
                  <allyText
                    class="form-group"
                    title="物件名"
                    name="propertyName"
                    v-model="propertyInfo.commonValue.propertyName"
                    :mode="mode"
                    :loading="loading"
                    :placeholder="'○○マンション'"
                    rules="required|max:40"
                    tips="物件の名称を入力します"
                  />
                </div>
                <div class="col-md-5">
                  <div class="">
                    <allyAddress
                      v-model="propertyInfo.commonValue.address"
                      :mode="mode"
                      :loading="loading"
                    />
                  </div>
                  <div>
                    <allyText
                      title="所有者"
                      name="owner"
                      v-model="propertyInfo.commonValue.owner"
                      :mode="mode"
                      :loading="loading"
                      :placeholder="'新井 太郎'"
                      rules="max:20"
                      tips="物件の所有者名を入力します"
                    />
                  </div>
                  <div>
                    <allyText
                      title="担当者"
                      name="staffName"
                      v-model="propertyInfo.commonValue.staffName"
                      :mode="mode"
                      :loading="loading"
                      :placeholder="'新井 太郎'"
                      rules="max:20"
                      tips="物件の担当者名を入力します"
                    />
                  </div>
                </div>
                <div class="col-md-1">
                  <div
                    class="col-6"
                    style="border-right: 1px solid rgb(154, 154, 154); height: 100%;"
                  ></div>
                </div>
                <div class="col-md-5">
                  <label v-if="propertyInfo.roomInfo.length > 0 || mode != 'View'">
                    <b style="font-size: 0.875rem;">部屋番号</b>
                  </label>
                  <div v-for="(room, index) of propertyInfo.roomInfo" :key="index">
                    <validation-provider
                      class="input-group mb-3"
                      style="background: #f7f7f7;"
                      :name="'部屋番号' + index"
                      rules="required|max:40"
                      v-slot="{ valid, errors }"
                    >
                      <b-form-input
                        type="text"
                        class="form-control mr-4"
                        v-model="room.roomName"
                        :disabled="mode == 'View'"
                        placeholder="１０１号室"
                        v-b-popover.hover="'部屋番号を入力します'"
                        :state="state(valid, errors, 'required|max:40', room.roomName)"
                      />
                      <div class="input-group-append">
                        <button
                          v-if="mode != 'View'"
                          class="btn btn-ally btn-outline-secondary"
                          type="button"
                          id="button-addon2"
                          @click="deleteRoom(index)"
                          v-b-popover.hover="'部屋番号を削除します'"
                        >
                          削除
                        </button>
                        <button
                          v-if="mode == 'View'"
                          class="btn btn-ally btn-outline-secondary"
                          type="button"
                          id="button-addon2"
                          @click="roomInfoUrl(room)"
                          v-b-popover.hover="'各部屋の詳細情報を表示します'"
                        >
                          詳細
                        </button>
                      </div>
                      <b-form-invalid-feedback
                        :state="state(valid, errors, 'required|max:40', room.roomName)"
                      >
                        {{ getErrorMessage(errors) }}
                      </b-form-invalid-feedback>
                    </validation-provider>
                  </div>
                  <div>
                    <button
                      v-if="mode != 'View'"
                      class="btn btn-ally mb-2"
                      @click="addRoom()"
                      :disabled="propertyInfo.roomInfo.length >= maxRoom"
                      v-b-popover.hover="'新たな部屋情報を追加します'"
                    >
                      追加
                    </button>
                    <span v-if="propertyInfo.roomInfo.length >= maxRoom" style="color: red;">
                      ※{{ maxRoom }}件を超える登録はできません</span
                    >
                  </div>
                  <allyTextArea
                    title="メモ"
                    name="memo"
                    :rows="memoTextAreaSize()"
                    rules="max:2400"
                    :mode="mode"
                    :loading="loading"
                    v-model="propertyInfo.commonValue.memo"
                    placeholder="特筆事項など"
                  />
                </div>
              </div>
            </div>
          </ValidationObserver>
          <div v-if="mode == 'View'" id="PropertyFunction">
            <div class="card">
              <div style="">
                <b-tabs fill pills v-model="selectFunction">
                  <b-tab title="ALLYフォト （画像シミュレーター） ">
                    <b-container style="margin: 0px; max-width:100%;">
                      <SimList />
                    </b-container>
                  </b-tab>
                  <b-tab title="ALLYオートスケッチ（部屋計測・間取図自動作成）">
                    <b-container style="margin: 0px; max-width:100%;">
                      <PlaneList />
                    </b-container>
                  </b-tab>
                </b-tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-if="!upLoading && !modalFlag">
      <div class="col-12">
        <button
          class="btn btn-ally float-right"
          v-on:click="create"
          v-if="mode == 'Add'"
          type="submit"
        >
          登録
        </button>
        <router-link
          :to="{
            path: '/Property/Edit/' + id,
          }"
          tag="button"
          class="btn btn-ally float-right"
          v-if="mode == 'View'"
          >編集</router-link
        >
        <button class="btn btn-ally float-right" v-if="mode == 'Edit'" v-on:click="update">
          保存
        </button>
        <router-link
          :to="{
            path: '/Property/View/' + id,
          }"
          tag="button"
          class="btn btn-ally float-right mr-3"
          v-if="mode == 'Edit'"
        >
          戻る
        </router-link>
      </div>
      <allyAlert code="S100" @okAction="pageLink()"></allyAlert>
      <allyAlert code="E0001"></allyAlert>
    </div>
  </div>
</template>
<script>
  import awsconfig from '../../aws-exports';
  import { API, graphqlOperation } from 'aws-amplify';

  //graphQL
  import { createProperty, updateProperty } from '../../graphql/mutations'; // 物件情報 新規作成、更新
  import { getProperty } from '../../graphql/queries'; // 物件情報 取得

  //コンポーネント
  import Load from '../../components/Common/Load'; // ローディング
  import SimList from './WallpaperSimulator/Main'; // ALLYフォト・リスト
  import PlaneList from './PlaneView/List'; // ALLYオートスケッチ・リスト
  import { v4 as uuidv4 } from 'uuid';

  API.configure(awsconfig);

  export default {
    components: {
      Load,
      SimList,
      PlaneList,
    },
    props: ['modalFlag'],
    data: function() {
      return {
        id: null, // ID
        mode: null, // 画面モード
        loading: true, // ローディングフラグ
        upLoading: false, // upload処理中フラグ
        propertyInfo: {
          // 物件情報
          commonValue: {
            propertyName: null, // 物件名
            roomNumber: null, // 部屋番号
            address: {
              //住所
              postalCode: null, // 郵便番号
              address1: null, // 都道府県
              address2: null, // 市区町村
              address3: null, // それ以降の住所
            },
            owner: null, // 所有者
            memo: null, // メモ
            staffName: null, // 担当者
          },
          roomInfo: [],
        },
        authType: null, // AuthType
        slidePlanView: [
          {
            img:
              'data:image/png;base64,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',
          },
        ],
        otherInfo: [{ text: 'その他タブ１' }, { text: 'その他タブ２' }, { text: 'その他タブ３' }],
        activeOtherInfo: 0,
        imageLoadFlag: false,
        disabled: true,
        selectFunction: 0,
        maxRoom: 100, // 部屋の最大登録数
      };
    },
    created: function() {
      if (this.$route.query.fun != null) this.selectFunction = Number(this.$route.query.fun);
    },
    mounted: async function() {
      // MOUNTED: ID, AuthTypeセット
      this.id = this.$route.params.id;
      this.authType = 'admin';

      // MOUNTED: ライセンスチェック
      this.disabled =
        !this.$store.state.functions?.some(v => {
          return v == 8; // ALLY フォト（画像シミュレーター）
        }) ?? false;

      // MOUNTED: 経路によってモードを設定
      if (this.$router.currentRoute.path.startsWith('/Property/Edit/')) {
        this.mode = 'Edit';
      } else if (this.$router.currentRoute.path.endsWith('/Add') || this.modalFlag) {
        this.mode = 'Add';
      } else {
        this.mode = 'View';
      }

      // MOUNTED: 編集、詳細画面の場合は会社情報をロードする
      if (this.mode == 'View' || this.mode == 'Edit') {
        var result = null;

        try {
          //物件情報を取得
          result = await API.graphql(
            graphqlOperation(getProperty, { company: this.getCompanyId(), id: this.id })
          );
        } catch {
          //モーダルを表示する。
          this.$bvModal.show('E0001');
          return;
        }

        // 会社情報を格納
        this.propertyInfo = result.data.getProperty;

        // roomInfoがnullの時、空の配列をセット
        if (this.propertyInfo.roomInfo == null) this.propertyInfo.roomInfo = [];

        delete this.propertyInfo.createdAt;
        delete this.propertyInfo.updatedAt;
      }

      this.loading = false;
    },
    methods: {
      /**
       * METHOD: タブクリック
       */
      clickTab: function(num) {
        this.activeOtherInfo = num;
      },
      /**
       * METHOD: 物件情報を追加する。
       */
      create: async function() {
        // バリデートチェック
        if (!(await this.$refs.propertyInfo.validate())) {
          // バリデートエラーがあれば終了する
          console.error('物件登録できません');
          return;
        }

        //upload処理中フラグ
        this.upLoading = true;

        // 物件情報に会社IDを追加
        var propertyInput = this.propertyInfo;
        propertyInput.company = this.getCompanyId();

        try {
          //物件情報 登録処理
          var result = await API.graphql(
            graphqlOperation(createProperty, {
              input: propertyInput,
            })
          );
          // 物件ID取得
          this.id = result.data.createProperty.id;

          // モーダルチェック
          if (!this.modalFlag) {
            // モーダル以外はViewへ遷移
            this.pageLink();
          } else {
            // モーダル時は物件情報を返す
            return result.data.createProperty;
          }

          //モーダルを表示する。
          //this.$bvModal.show('S100');
        } catch (e) {
          console.error(e);
          //モーダルを表示する。
          this.$bvModal.show('E0001');
          return;
        } finally {
          this.upLoading = false;
        }
      },
      /**
       * METHOD: 物件情報を更新する。
       */
      update: async function() {
        this.$refs.propertyInfo.validate().then(async propertyValid => {
          if (propertyValid) {
            //upload処理中フラグ
            this.upLoading = true;

            var updloadData = null;
            updloadData = this.propertyInfo;

            try {
              //データ更新処理
              await API.graphql({
                query: updateProperty,
                variables: { input: updloadData },
              });
              //モーダルを表示する。
              //this.$bvModal.show('S100');

              this.pageLink();
            } catch {
              //モーダルを表示する。
              this.$bvModal.show('E0001');
              this.upLoading = false;
              return;
            }
          }
        });
      },
      /**
       * METHOD: 変更完了時ページリンク先
       */
      pageLink: function() {
        //更新前ページ遷移を警告する機能を閉じる。
        this.$store.commit('setSaveFlg', true);

        //viewに移動
        this.$router.push('/Property/View/' + this.id);
      },
      /**
       * METHOD: 会社情報を取得する。
       */
      getCompanyId: function() {
        //アカウントから会社ID取得
        var groups = this.$store.state.user.signInUserSession.accessToken.payload['cognito:groups'];
        var groupIndex = groups.findIndex(group => {
          return group.startsWith('Company-');
        }, 'Company-');
        return groups[groupIndex];
      },
      /**
       * METHOD: フォトシミュと平面図の切り替えを行う
       */
      clickFuncChange(num) {
        this.selectFunction = num;
      },
      /**
       * METHOD: 部屋情報を追加する。
       */
      addRoom: async function() {
        if (this.propertyInfo.roomInfo == null) this.propertyInfo.roomInfo = [];

        if (this.propertyInfo.roomInfo.length >= this.maxRoom) return;
        let uuid = await uuidv4();
        this.propertyInfo.roomInfo.push({
          id: uuid,
          roomName: '',
        });
      },
      /**
       * METHOD: 部屋を削除する。
       */
      deleteRoom(num) {
        this.propertyInfo.roomInfo.splice(num, 1);
      },
      /** METHOD: 部屋情報画面へ移動する。 */
      roomInfoUrl(room) {
        let jamp = '/Property/View/' + this.id + '/RoomView/' + room.id;
        if (this.selectFunction != 0) jamp += '?fun=' + this.selectFunction;
        this.$router.push(jamp);
      },
      /**
       * METHOD: 状態
       *  */
      state: function(valid, errors, rules, result) {
        if (
          (errors[0] || (rules && result) || (rules && rules.includes('required') && result)) &&
          this.mode != 'View'
        ) {
          return errors[0] ? false : valid ? true : null;
        }
        return null;
        // valid status
      },
      /**
       * METHOD: メモエリアサイズ取得
       *  */
      memoTextAreaSize() {
        let size = 26 - this.propertyInfo.roomInfo.length * 4.5;
        if (size < 6) size = 6;
        return size;
      },
      /**
       * METHOD: エラーメッセージ取得
       *  */
      getErrorMessage(errors) {
        if (errors.length == 0) return null;
        return errors[0].replace(/[0-9]/g, '');
      },
    },
  };
</script>

<style scoped>
  .property-icon {
    font-size: 5rem;
    color: var(--colorTheme);
    transition: 0.2s;
  }

  .property-back-color {
    border-radius: 20px 20px 20px 20px;
    transition: 0.2s;
  }

  .property-back-color:hover {
    background-color: #ffffff;
    border-radius: 20px 20px 20px 20px;
  }
  .property-function-icon {
    max-width: 220px;
  }

  .line {
    display: inline-block;
  }

  .hooper-slide {
    background-color: #444444;
    padding: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    border: 2px solid #fff;
    font-size: 30px;
    border-radius: 10px;
  }

  .otherTab {
    font-size: 20px;
    color: black;
    background-color: white;
    border: 2px solid #fff;
    height: 50px;
    transition: 0.2s;
  }
  .otherTab:hover {
    color: white;
    background-color: var(--colorTheme);
  }
  .otherTab.active {
    color: white;
    background-color: var(--colorTheme);
  }
  .disabled {
    color: lightgray;
  }

  .itemfunc {
    position: relative;
    text-align: center;
    border: 1px solid;
    min-height: 90px;
    height: auto;
    font-size: 18px;
    display: table;
    width: 100%;
    font-weight: bold;
    cursor: pointer;
    cursor: hand;
  }

  .itemfunc.select {
    color: white;
    background-color: var(--colorTheme);
  }
  .ally-input-background .card {
    border-top-color: gainsboro !important;
  }
  .card {
    border-top-color: gainsboro !important;
  }
</style>
<style>
  #PropertyFunction .nav-pills .nav-link.active {
    background-color: var(--colorTheme);
    margin-left: 1px;
    margin-right: 1px;
  }
  #PropertyFunction .nav-pills .nav-link {
    background-color: gainsboro;
    padding-top: 20px;
    padding-bottom: 20px;
    font-size: 18px;
    font-weight: bold;
  }
</style>
